import * as React from 'react';

const LogoRoomsApp = (props) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={109} height={110} viewBox='0 0 35 35' fill='none' {...props}>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M34.7823 4.40875V30.3736C34.7823 32.8084 32.8085 34.7822 30.3737 34.7822H4.40876C1.974 34.7822 0 32.8084 0 30.3736V4.40875C0 1.97399 1.974 0 4.40876 0H30.3737C32.8085 0 34.7823 1.97399 34.7823 4.40875Z'
			fill='#121210'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M29.3163 12.6729C30.0137 12.6729 30.5789 13.2359 30.5789 13.9344C30.5789 16.6853 30.5789 23.2024 30.5789 25.9563C30.5789 26.6517 30.0137 27.2179 29.3163 27.2179H5.7544C5.0573 27.2179 4.49219 26.6517 4.49219 25.9563V13.9344C4.49219 13.2359 5.0573 12.6729 5.7544 12.6729C10.1709 12.6729 24.9002 12.6729 29.3163 12.6729Z'
			fill='#FF7043'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M14.9574 12.7348H12.5156C12.5156 9.88206 14.7486 7.56836 17.5019 7.56836C20.2515 7.56836 22.4846 9.88206 22.4846 12.7348H20.0428C20.0428 11.2791 18.9033 10.0984 17.5019 10.0984C16.0969 10.0984 14.9574 11.2791 14.9574 12.7348Z'
			fill='#FF7043'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M24.4592 14.8872C24.7047 14.8872 24.9039 15.0865 24.9039 15.3318L24.9039 24.4723C24.9039 24.7177 24.7047 24.917 24.4592 24.917C24.2139 24.917 24.0146 24.7177 24.0146 24.4723L24.0146 15.3318C24.0146 15.0865 24.2139 14.8872 24.4592 14.8872Z'
			fill='#F20D0D'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M10.5627 14.8872C10.8082 14.8872 11.0074 15.0865 11.0074 15.3318L11.0074 24.4723C11.0074 24.7177 10.8082 24.917 10.5627 24.917C10.3174 24.917 10.1182 24.7177 10.1182 24.4723L10.1182 15.3318C10.1182 15.0865 10.3174 14.8872 10.5627 14.8872Z'
			fill='#F20D0D'
		/>
	</svg>
);
export default LogoRoomsApp;
